/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDevicesGetQueryResponse, StreamerBoxStreamerBoxDevicesGetPathParams } from "../models/StreamerBoxStreamerBoxDevicesGet";

export function getStreamerBoxStreamerBoxDevicesGetUrl(uuidOrId: StreamerBoxStreamerBoxDevicesGetPathParams["uuidOrId"]) {
  const res = { method: 'GET', url: `/streamer-box/devices/${uuidOrId}` as const }
  return res
}

/**
 * @description Returns a single Balena device by numeric id or UUID.
 * @summary Get device
 * {@link /streamer-box/devices/:uuidOrId}
 */
export async function streamerBoxStreamerBoxDevicesGet(uuidOrId: StreamerBoxStreamerBoxDevicesGetPathParams["uuidOrId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDevicesGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStreamerBoxStreamerBoxDevicesGetUrl(uuidOrId).url.toString(), ... requestConfig })
  return res.data
}